<iframe 
    src="../../../../assets/KurentoVideo/Test2.html?username={{userName}}&channelname={{channelId}}" 
    width="100%" 
    height="100%" 
    class="video-frame">
</iframe> 